// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3H1to","footer":"ReportModalFilter_footer__2jcve"};